import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.nav`
  padding: 15px 20px;
  background: var(--glass-1);
  border: 1px solid var(--glass-border);
  backdrop-filter: blur(var(--glass-blur, 10px));
  border-radius: var(--radius-sm, 8px);
  width: ${props => props.width || '100%'};
`;

const TocTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;

  svg { width: 16px; height: 16px; color: var(--accent); }
`;

const TocList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;

const TocItem = styled.li`
  margin-bottom: 8px;
  font-size: 13px;
  color: var(--text-secondary);
  padding-left: ${props => (props.level * 15)}px;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    left: ${props => (props.level * 15) - 10}px;
    top: 8px;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: var(--glass-border-hover);
  }

  &:hover {
    color: var(--accent);
    cursor: pointer;
  }
`;

const TableOfContentsWidget = ({ node }) => {
  const title = node.content?.title || 'Inhaltsverzeichnis';
  const width = node.style?.desktop?.width || '100%';

  // Dummy Items für den Designer
  const items = [
    { title: 'Einleitung & Übersicht', level: 0 },
    { title: 'Die wichtigsten Features', level: 0 },
    { title: 'Feature A im Detail', level: 1 },
    { title: 'Feature B im Detail', level: 1 },
    { title: 'Preise & Tarife', level: 0 },
    { title: 'Zusammenfassung', level: 0 }
  ];

  return (
    <div style={{ display: 'flex', justifyContent: node.style?.desktop?.align || 'flex-start' }}>
      <Wrapper width={width}>
        <TocTitle>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 6h16M4 12h16M4 18h16"></path></svg>
          {title}
        </TocTitle>
        <TocList>
          {items.map((item, idx) => (
            <TocItem key={idx} level={item.level}>{item.title}</TocItem>
          ))}
        </TocList>
      </Wrapper>
    </div>
  );
};

registry.register('table_of_contents', {
  label: 'TOC / Inhaltsverz.',
  icon: '📑',
  category: 'advanced',
  defaultContent: {
    title: 'Inhaltsverzeichnis'
  },
  defaultStyle: {
    desktop: {
      width: '100%',
      align: 'flex-start'
    }
  },
  render: TableOfContentsWidget,
  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Allgemein',
          fields: [
            { name: 'content.title', label: 'Titelanzeige', type: 'text' }
          ]
        }
      ]
    },
    {
      tab: 'style',
      groups: [
        {
          title: 'Layout',
          fields: [
            { name: 'style.desktop.width', label: 'Breite', type: 'text' },
            { name: 'style.desktop.align', label: 'Container Ausrichtung', type: 'select', options: [{label:'Links',value:'flex-start'}, {label:'Zentriert',value:'center'}, {label:'Rechts',value:'flex-end'}] }
          ]
        }
      ]
    }
  ]
});
